import { INiche, INicheMap } from "services/types";

export const filterNichesList = (prevNiches: INicheMap, newNiches: INiche[]) => {
  const niches = { ...prevNiches };

  newNiches.forEach((niche: INiche) => {
    niches[niche.id] = niche;
  });

  return niches;
};
